import {Space} from "antd";
import {LiveEventEventTypeTopicTypeFormFields} from "./topic-type";
import {LiveEventEventTypeTopicTypeFormFieldsProps} from "./types";

export function LiveEventEventTypeFormFields({
  formType,
}: LiveEventEventTypeTopicTypeFormFieldsProps) {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <LiveEventEventTypeTopicTypeFormFields formType={formType} />
    </Space>
  );
}
